module.exports = {"id":"203843","name":"Damián Suárez","rating":"74","photo":"./data/images/photos/0/203843.png","club":{"name":"Getafe CF","logo":"./data/images/clubs/GetafeCF.png"},"positions":["DD","DG","DLD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DamianSuarez0.json
// module id = 905
// module chunks = 0